<template>
  <div>
    <div class="page-header">
      <v-btn class="back-btn mb-3 px-4 py-4" outlined @click="goBack">
        <img src="./assets/back-icon.svg" alt="" class="back-btn-icon" />
        Назад
      </v-btn>
      <div class="page-header-title-row">
        <div class="text-h6 text-sm-h4">
          {{
            recommendation
              ? "Индивидуальное предложение"
              : "Индивидуальные рекомендации"
          }}
        </div>
        <div v-if="recommendation" class="page-header-actions">
          <v-btn class="page-header-action-btn" @click="copyToClipboard">
            <img
              src="./assets/check.gif"
              alt=""
              class="page-header-action-btn-icon"
            />
            Скопировать
          </v-btn>
          <v-menu v-model="exportMenuOpen" offset-y left>
            <template #activator="{ on, attrs }">
              <v-btn class="page-header-action-btn" v-bind="attrs" v-on="on">
                <img
                  src="./assets/check.gif"
                  alt=""
                  class="page-header-action-btn-icon"
                />
                Экспорт
                <v-icon right small>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="onExportPdf">
                <v-list-item-title>PDF</v-list-item-title>
              </v-list-item>
              <v-list-item @click="onExportDoc">
                <v-list-item-title>DOC</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>

    <div class="recommendation-layout">
      <div
        class="recommendation-main-wrap"
        :class="{
          'recommendation-main-wrap--with-side': !recommendation && !loading,
        }"
      >
        <v-card
          class="recommendation-card pa-3"
          :class="{
            'recommendation-card--loading': loading,
            'recommendation-card--full-width': loading || recommendation,
          }"
        >
          <div
            v-if="!recommendation && !loading"
            class="recommendation-card-header px-4"
          >
            <h2 class="recommendation-card-title">Информация о ребенке</h2>
            <p class="recommendation-card-subtitle">
              Введите данные о ребенке, что AI помощник сформировал
              <strong>Индивидуальное предложение</strong>
            </p>
          </div>
          <v-card-text
            class="pt-0"
            :class="{ 'recommendation-card-text--loading': loading }"
          >
            <div v-if="loading" class="recommendation-loading">
              <img
                src="./assets/loading.gif"
                alt=""
                class="recommendation-loading-icon"
              />
              <p class="recommendation-loading-text">
                Минутку... Формируем предложение
              </p>
            </div>
            <div v-else-if="!recommendation">
              <v-form ref="form" class="recommendation-form">
                <v-row>
                  <v-col cols="12" sm="6" md="8">
                    <div class="recommendation-field">
                      <v-text-field
                        v-model="childName"
                        placeholder="ФИО ребенка"
                        flat
                        solo
                        dense
                        hide-details
                        class="recommendation-input-compact"
                        style="border: 1px solid #23919e; border-radius: 6px"
                      ></v-text-field>
                      <div
                        v-if="fieldErrors.childName.length"
                        class="recommendation-field-error"
                      >
                        {{ fieldErrors.childName[0] }}
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6" md="4">
                    <div class="recommendation-field">
                      <v-text-field
                        v-model="childAge"
                        placeholder="Возраст ребенка"
                        type="number"
                        flat
                        solo
                        dense
                        hide-details
                        class="recommendation-input-compact"
                        style="border: 1px solid #23919e; border-radius: 6px"
                      ></v-text-field>
                      <div
                        v-if="fieldErrors.childAge.length"
                        class="recommendation-field-error"
                      >
                        {{ fieldErrors.childAge[0] }}
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <div class="recommendation-field recommendation-textarea-wrap">
                  <v-textarea
                    v-model="description"
                    placeholder="Вставьте в поле сообщения от родителей, описание ребёнка, анамнез, симптомы, жалобы или любые другие данные, которые помогут составить индивидуальное предложение"
                    flat
                    solo
                    hide-details
                    class="recommendation-input-compact recommendation-textarea"
                    style="border: 1px solid #23919e; border-radius: 6px"
                    rows="6"
                  ></v-textarea>
                  <div
                    v-if="fieldErrors.description.length"
                    class="recommendation-field-error"
                  >
                    {{ fieldErrors.description[0] }}
                  </div>
                </div>

                <input
                  ref="fileInput"
                  type="file"
                  accept="image/*,.pdf,.doc,.docx"
                  multiple
                  class="d-none"
                  @change="
                    handleFileUpload($event.target.files);
                    $event.target.value = '';
                  "
                />

                <v-chip-group v-if="filesData.length > 0" column class="mt-2">
                  <v-chip
                    v-for="(file, index) in filesData"
                    :key="index"
                    close
                    @click:close="removeFile(index)"
                    color="primary"
                    outlined
                  >
                    <v-icon left small>
                      {{
                        file.type === "image"
                          ? "mdi-image"
                          : "mdi-file-document"
                      }}
                    </v-icon>
                    {{ file.name }}
                  </v-chip>
                </v-chip-group>

                <v-row v-if="imagePreviews.length > 0" class="mt-2">
                  <v-col
                    v-for="(preview, index) in imagePreviews"
                    :key="index"
                    cols="6"
                    sm="3"
                  >
                    <v-card>
                      <v-img
                        :src="preview.data"
                        max-height="150"
                        contain
                        class="preview-image"
                      ></v-img>
                      <v-card-actions class="pa-1">
                        <v-spacer></v-spacer>
                        <v-btn icon x-small @click="removeFile(preview.index)">
                          <v-icon small>mdi-close</v-icon>
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-form>
            </div>

            <div v-else>
              <div
                class="recommendation-content"
                v-html="formattedRecommendation"
              ></div>
            </div>
          </v-card-text>

          <v-card-actions
            v-if="!recommendation && !loading"
            class="recommendation-card-actions"
          >
            <v-tooltip bottom max-width="320">
              <template #activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="recommendation-plus-btn"
                  :disabled="filesData.length >= 4"
                  @click="$refs.fileInput.click()"
                >
                  <img
                    src="./assets/plus.gif"
                    alt=""
                    class="recommendation-plus-icon"
                  />
                </v-btn>
              </template>
              <span>
                Загрузить файлы или изображения (до 4 файлов). AI проанализирует
                изображения или извлечет текст из документов (PDF, DOC,
                DOCX).</span
              >
            </v-tooltip>
            <v-btn
              color="#d86568"
              large
              rounded
              class="white--text recommendation-ai-btn ml-2"
              :disabled="loading"
              :loading="loading"
              @click="generateRecommendation"
              width="300"
            >
              Запустить AI помощника
              <img src="./assets/stick.gif" alt="" class="btn-icon-right" />
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </div>
      <aside
        v-if="!recommendation && !loading"
        class="recommendation-side-card"
      >
        <div class="recommendation-side-card-inner">
          <div class="recommendation-side-card-header">
            <div class="recommendation-side-card-icon-wrap">
              <img
                src="./assets/question-ellipse.svg"
                alt=""
                class="recommendation-side-card-ellipse"
              />
              <img
                src="./assets/question.gif"
                alt=""
                class="recommendation-side-card-question"
              />
            </div>
            <h3 class="recommendation-side-card-title">Назначение раздела</h3>
          </div>
          <div class="recommendation-side-card-text">
            <p>
              В этом разделе вы можете собрать всю информацию о ребёнке и на её
              основе сформировать индивидуальное предложение по методу UpMIND+.
            </p>
            <p>
              Сюда можно вставить сообщения от родителей, анамнез, описание
              симптомов, а также загрузить заключения специалистов.
            </p>
          </div>
        </div>
      </aside>
    </div>

    <v-snackbar v-model="snackbar" :timeout="3000" :color="snackbarColor">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import NSApi from "@/api/NSApi";
import { Document, Packer, Paragraph, TextRun } from "docx";
import { saveAs } from "file-saver";
import html2pdf from "html2pdf.js";

export default {
  name: "CompanyRecommendationView",
  data() {
    return {
      childName: "",
      childAge: "",
      description: "",
      imagePreviews: [],
      filesData: [],
      recommendation: "",
      loading: false,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      exportMenuOpen: false,
      fieldErrors: {
        childName: [],
        childAge: [],
        description: [],
      },
    };
  },
  computed: {
    formValid() {
      return (
        this.childName.trim() !== "" &&
        this.childAge !== "" &&
        !isNaN(Number(this.childAge)) &&
        Number(this.childAge) > 0 &&
        this.description.trim() !== ""
      );
    },
    formattedRecommendation() {
      if (!this.recommendation) return "";
      return this.recommendation.replace(/\n/g, "<br>");
    },
  },
  methods: {
    goBack() {
      const userRole = this.$store.state.user?.role;
      const routeName = this.$route.name || "";
      const segment = routeName.includes("adults")
        ? "adults"
        : routeName.includes("children")
        ? "children"
        : null;
      if (userRole === "admin") {
        const name = segment ? `admin-parents-${segment}` : "admin-parents";
        this.$router.push({ name });
      } else if (userRole === "manager") {
        const name = segment ? `manager-parents-${segment}` : "manager-parents";
        this.$router.push({ name });
      } else if (userRole === "company-user" || userRole === "company-owner") {
        const name = segment ? `company-parents-${segment}` : "company-parents";
        this.$router.push({ name });
      } else {
        this.$router.push("/");
      }
    },
    resetForm() {
      this.childName = "";
      this.childAge = "";
      this.description = "";
      this.imagePreviews = [];
      this.filesData = [];
      this.recommendation = null;
      this.loading = false;
      this.fieldErrors = {
        childName: [],
        childAge: [],
        description: [],
      };
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
    validateForm() {
      const errors = {
        childName: [],
        childAge: [],
        description: [],
      };
      if (!this.childName || !this.childName.trim()) {
        errors.childName.push("Обязательное поле");
      }
      const age = Number(this.childAge);
      if (
        this.childAge === "" ||
        this.childAge === null ||
        this.childAge === undefined
      ) {
        errors.childAge.push("Обязательное поле");
      } else if (isNaN(age) || age <= 0) {
        errors.childAge.push("Введите корректный возраст");
      }
      if (!this.description || !this.description.trim()) {
        errors.description.push("Обязательное поле");
      }
      this.fieldErrors = errors;
      return (
        errors.childName.length === 0 &&
        errors.childAge.length === 0 &&
        errors.description.length === 0
      );
    },
    async handleFileUpload(files) {
      if (!files || files.length === 0) {
        return;
      }

      const remainingSlots = 4 - this.filesData.length;

      if (files.length > remainingSlots) {
        this.snackbarText = `Можно добавить еще ${remainingSlots} файл(ов). Всего максимум 4 файла.`;
        this.snackbarColor = "error";
        this.snackbar = true;
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = "";
        }
        return;
      }

      for (const file of files) {
        const fileName = file.name.toLowerCase();
        const isImage = file.type.startsWith("image/");
        const isPDF =
          fileName.endsWith(".pdf") || file.type === "application/pdf";
        const isDoc = fileName.endsWith(".doc");
        const isDocx =
          fileName.endsWith(".docx") ||
          file.type ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document";

        if (!isImage && !isPDF && !isDoc && !isDocx) {
          this.snackbarText = `Файл ${file.name}: поддерживаются только изображения, PDF, DOC и DOCX файлы`;
          this.snackbarColor = "error";
          this.snackbar = true;
          continue;
        }

        await this.processFile(file, isImage, isPDF, isDoc, isDocx);
      }

      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
    removeFile(index) {
      this.filesData.splice(index, 1);

      this.imagePreviews = [];
      this.filesData.forEach((file, idx) => {
        if (file.type === "image") {
          this.imagePreviews.push({
            data: `data:image/jpeg;base64,${file.data}`,
            index: idx,
          });
        }
      });
    },
    async processFile(file, isImage, isPDF, isDoc, isDocx) {
      return new Promise((resolve) => {
        if (isImage) {
          const img = new Image();
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d");

          img.onload = () => {
            let width = img.width;
            let height = img.height;
            const maxDimension = 1920;

            if (width > maxDimension || height > maxDimension) {
              if (width > height) {
                height = (height / width) * maxDimension;
                width = maxDimension;
              } else {
                width = (width / height) * maxDimension;
                height = maxDimension;
              }
            }

            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);

            const compressedDataURL = canvas.toDataURL("image/jpeg", 0.85);
            const base64Data = compressedDataURL.split(",")[1];

            const newIndex = this.filesData.length;

            this.filesData.push({
              name: file.name,
              type: "image",
              data: base64Data,
            });

            this.imagePreviews.push({
              data: compressedDataURL,
              index: newIndex,
            });

            resolve();
          };

          const reader = new FileReader();
          reader.onload = (e) => {
            img.src = e.target.result;
          };
          reader.readAsDataURL(file);
        } else {
          const reader = new FileReader();
          reader.onload = (e) => {
            const base64Data = e.target.result.split(",")[1];

            if (isPDF) {
              this.filesData.push({
                name: file.name,
                type: "pdf",
                data: base64Data,
              });
            } else if (isDocx) {
              this.filesData.push({
                name: file.name,
                type: "docx",
                data: base64Data,
              });
            } else if (isDoc) {
              this.filesData.push({
                name: file.name,
                type: "doc",
                data: base64Data,
              });
            }

            resolve();
          };
          reader.readAsDataURL(file);
        }
      });
    },
    async generateRecommendation() {
      if (!this.validateForm()) return;

      this.loading = true;
      try {
        const response = await NSApi.instance.generateIndividualRecommendation(
          this.childName,
          this.childAge,
          this.description,
          this.filesData
        );
        this.recommendation = response.recommendation;
      } catch (error) {
        this.snackbarText =
          error.response?.data?.message || "Ошибка при генерации рекомендаций";
        this.snackbarColor = "error";
        this.snackbar = true;
      } finally {
        this.loading = false;
      }
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.recommendation).then(() => {
        this.snackbarText = "Скопировано в буфер обмена";
        this.snackbarColor = "success";
        this.snackbar = true;
      });
    },
    onExportPdf() {
      this.exportMenuOpen = false;
      this.exportToPdf();
    },
    onExportDoc() {
      this.exportMenuOpen = false;
      this.exportToDoc();
    },
    exportToPdf() {
      const content = `
        <div style="font-family: Arial, sans-serif; padding: 40px; line-height: 1.6;">
          <h1 style="color: #23919e; margin-bottom: 20px;">Индивидуальное предложение</h1>
          <div style="margin-bottom: 20px; font-weight: bold;">ФИО ребенка: ${this.childName}</div>
          <div style="margin-bottom: 20px; font-weight: bold;">Возраст: ${this.childAge}</div>
          <div style="white-space: pre-wrap; word-wrap: break-word;">${this.recommendation}</div>
        </div>
      `;

      const element = document.createElement("div");
      element.innerHTML = content;

      const opt = {
        margin: 10,
        filename: `recommendation_${this.childName}_${
          new Date().toISOString().split("T")[0]
        }.pdf`,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };

      html2pdf().set(opt).from(element).save();

      this.snackbarText = "PDF файл загружается";
      this.snackbarColor = "success";
      this.snackbar = true;
    },
    async exportToDoc() {
      const doc = new Document({
        sections: [
          {
            children: [
              new Paragraph({
                children: [
                  new TextRun({
                    text: "Индивидуальное предложение",
                    bold: true,
                    size: 32,
                  }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: `ФИО ребенка: ${this.childName}`,
                    size: 24,
                  }),
                ],
              }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: `Возраст: ${this.childAge}`,
                    size: 24,
                  }),
                ],
              }),
              new Paragraph({ text: "" }),
              new Paragraph({
                children: [
                  new TextRun({
                    text: this.recommendation,
                    size: 24,
                  }),
                ],
              }),
            ],
          },
        ],
      });

      const blob = await Packer.toBlob(doc);
      saveAs(blob, `recommendation_${this.childName}.docx`);

      this.snackbarText = "DOC файл загружен";
      this.snackbarColor = "success";
      this.snackbar = true;
    },
  },
};
</script>

<style scoped>
.page-header {
  margin: 16px 0 24px 0;
}

.back-btn {
  max-width: 154px;
  border-radius: 20px;
  background-color: white;
  color: #23919e !important;
  border: 1px solid #e0e0e0;
  text-transform: none;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 27px !important;
  letter-spacing: normal;
  padding: 12px 20px !important;
  min-height: auto;
}

.back-btn .v-btn__content {
  font-size: 16px;
  line-height: 27px;
  font-weight: 600;
  padding: 0 4px;
}

.back-btn-icon {
  height: 20px;
  width: auto;
  margin-right: 6px;
  vertical-align: middle;
}

.back-btn:hover {
  background-color: #f5f5f5;
  border-color: #e0e0e0;
}

.recommendation-layout {
  display: flex;
  align-items: flex-start;
  gap: 60px;
}

.recommendation-side-card {
  flex-shrink: 0;
  width: 311px;
  height: 600px;
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  box-shadow: none;
}

.recommendation-side-card-inner {
  flex: 1;
  background-color: #f0f8f6;
  border-radius: 6px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.recommendation-side-card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.recommendation-side-card-icon-wrap {
  position: relative;
  display: inline-block;
  width: 74px;
  height: 69px;
}

.recommendation-side-card-ellipse {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.recommendation-side-card-question {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 36px;
  height: auto;
  object-fit: contain;
}

.recommendation-side-card-title {
  margin: 0;
  font-size: 1.375rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.recommendation-side-card-text {
  flex: 1;
  font-size: 0.875rem;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.7);
}

.recommendation-side-card-text p {
  margin: 0 0 12px 0;
}

.recommendation-side-card-text p:last-child {
  margin-bottom: 0;
}

.recommendation-main-wrap {
  flex: 1;
  min-width: 0;
}

.recommendation-main-wrap--with-side {
  max-width: calc(100% - 311px - 60px);
}

.recommendation-card {
  width: 100%;
}

.recommendation-card--full-width {
  max-width: none;
  width: 100%;
}

.recommendation-card--loading {
  height: calc(100vh - 280px);
  display: flex;
  flex-direction: column;
}

.recommendation-card--loading >>> .v-card__text {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.recommendation-card-text--loading .recommendation-loading {
  flex: 1;
  min-height: 0;
}

.recommendation-card-header {
  padding-top: 20px;
  padding-bottom: 8px;
}

.recommendation-card-title {
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0 0 8px 0;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.87);
}

.recommendation-card-subtitle {
  font-size: 0.875rem;
  margin: 0 0 16px 0;
  line-height: 1.5;
  max-width: 593px;
  color: rgba(0, 0, 0, 0.6);
}

.recommendation-field {
  margin-bottom: 4px;
}

.recommendation-textarea-wrap {
  margin-top: 24px;
}

.recommendation-field-error {
  font-size: 12px;
  color: #ff5252;
  margin-top: 4px;
  margin-bottom: 8px;
  line-height: 1.2;
}

.recommendation-form .recommendation-input-compact >>> .v-input__control,
.recommendation-form .recommendation-input-compact >>> .v-input__slot {
  min-height: 40px !important;
}

.recommendation-form .recommendation-textarea >>> .v-input__control,
.recommendation-form .recommendation-textarea >>> .v-input__slot {
  min-height: 120px !important;
  align-items: flex-start;
}

.page-header-title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex: 1;
  min-width: 0;
}

.page-header-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.page-header-action-btn {
  background-color: white !important;
  border-radius: 20px !important;
  border: 1px solid #e0e0e0 !important;
  color: #23919e !important;
  text-transform: none;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 27px !important;
  letter-spacing: normal;
  padding: 12px 20px !important;
  min-height: auto !important;
  box-shadow: none !important;
}

.page-header-action-btn .v-btn__content {
  font-size: 16px;
  line-height: 27px;
  font-weight: 600;
  padding: 0 4px;
}

.page-header-action-btn:hover {
  background-color: #f5f5f5 !important;
  border-color: #e0e0e0 !important;
}

.page-header-action-btn .v-icon {
  color: #23919e !important;
}

.page-header-action-btn-icon {
  height: 20px;
  width: auto;
  margin-right: 6px;
  vertical-align: middle;
}

.recommendation-result-title {
  margin: 0 0 16px 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
}

.recommendation-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  padding: 40px 20px;
}

.recommendation-loading-icon {
  width: 300px;
  height: 300px;
  object-fit: contain;
  display: block;
  margin-bottom: 16px;
}

.recommendation-loading-text {
  margin: 0;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.7);
}

.recommendation-content {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  max-height: 500px;
  overflow-y: auto;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.preview-image {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 4px;
}

.btn-icon-right {
  height: 20px;
  width: auto;
  margin-left: 8px;
  vertical-align: middle;
}

.recommendation-card-actions {
  padding-top: 8px;
}

.recommendation-plus-btn {
  padding: 19px 15px !important;
  border-radius: 50px !important;
  border: 1px solid #23919e !important;
  min-width: 0 !important;
}

.recommendation-plus-icon {
  height: 20px;
  width: auto;
  display: block;
}
</style>
